import React, { useState } from "react";
import { Box, Avatar } from "@mui/material";
import { getMarketingHeadshotUrl } from "../../utils/marketingHeadshots";

const HEADSHOT_RING = { padding: "2px", glow: "35", spread: 12 };

/**
 * Marketing-only headshot: public MLB / NBA / ESPN CDNs, no API/R2 roundtrip.
 * Compare page continues to use CompareHeadshotRing → PlayerHeadshot → usePlayerPhoto.
 */
const MarketingHeadshot = ({ playerId, size, accent, name }) => {
  const [error, setError] = useState(false);
  const photoUrl = getMarketingHeadshotUrl(playerId);

  return (
    <Box
      sx={{
        borderRadius: "50%",
        p: HEADSHOT_RING.padding,
        background: `linear-gradient(135deg, ${accent}, ${accent}55)`,
        boxShadow: `0 0 ${HEADSHOT_RING.spread}px ${accent}${HEADSHOT_RING.glow}`,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          overflow: "hidden",
          bgcolor: "background.paper",
        }}
      >
        {photoUrl && !error ? (
          <img
            src={photoUrl}
            alt={name ? `${name} headshot` : "Player headshot"}
            width={size}
            height={size}
            loading="eager"
            fetchpriority="high"
            decoding="async"
            onError={() => setError(true)}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <Avatar
            sx={{
              width: "100%",
              height: "100%",
              fontSize: size * 0.4,
              bgcolor: "primary.main",
            }}
          >
            {playerId?.charAt(0)?.toUpperCase() ?? "?"}
          </Avatar>
        )}
      </Box>
    </Box>
  );
};

export default MarketingHeadshot;
